import React from 'react';
import { Navigate } from 'react-router-dom';
import { ReviseFreePapers } from '../components/marketing/revise/FreePapers';
import { FREE_PAGE } from '../components/marketing/revise/content';
import { useMarketingTheme } from '../context/TenantContext';
import { useDocumentMeta } from '../lib/useDocumentMeta';

/**
 * `/free` — the six free NSC papers.
 *
 * The route exists for every published tenant because App.tsx registers it
 * beside `/courses`, but the page is bespoke to one: every word of it is about
 * the NSC, and `revise` is already allowlisted to a single tenant. Any other
 * theme is sent to the catalogue, which is the nearest thing that means the
 * same — "here is what you can have" — rather than a 404 or, worse, this
 * content rendered in a shell it was not drawn for.
 *
 * `replace` so the redirect doesn't sit in history: someone who lands here by
 * accident and presses back should leave, not bounce.
 */
export const FreePapers: React.FC = () => {
  const theme = useMarketingTheme();

  useDocumentMeta(theme === 'revise' ? FREE_PAGE.meta : {});

  if (theme !== 'revise') return <Navigate to="/courses" replace />;
  return <ReviseFreePapers />;
};
